<template>
    <v-container fluid class="pa-0">
        <template v-if="loading">
            <v-overlay :value="loading">
                <v-progress-circular :size="100" color="white" indeterminate></v-progress-circular>
            </v-overlay>
        </template>
        <template v-else>
            <banner 
                :title="$t('RatePageTitle')"
                :description="$t('RatePageDescription')" 
            />
            <v-container>
                <template v-if="formSubmited">
                    <v-alert
                        max-width="650"
                        type="success"
                        prominent
                        class="mt-6 mx-auto"
                    >
                        <div class="d-flex align-center justify-space-between">
                            <span class="font-weight-medium">{{ $t('SuccessfulRateSessionNotification') }}</span> 
                            <v-btn outlined rounded :to="`/${$i18n.locale}/student/sessions`">{{ $t('Sessions') }}</v-btn>
                        </div>
                    </v-alert>
                </template>
                <template v-else>
                    <v-card 
                        outlined
                        class="mx-auto custom-radius" 
                        style="max-width: 760px;"
                    >
                        <v-row class="pl-4" justify="space-between">
                            <v-col cols="12" class="d-flex align-center pa-3">
                                <div 
                                    v-show="tutorData.photo != null && tutorData.photo != undefined"
                                    :style="`background-image: url('${baseImageUrl}${tutorData.photo}');`"
                                    class="avatar-container d-inline-flex ma-4 ml-0"
                                ></div>
                                <div>
                                    <div class="headline">{{tutorData.fullName}}</div>
                                    <div class="subtitle-1 mb-4">({{tutorData.countryName}})</div>
                                    <v-chip outlined color="primary" v-text="teachingSubject.label"></v-chip>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <template v-if="!showReviewBox">
                            <v-card-actions class="pa-4 d-flex align-center">
                                <span class="subtitle-1 font-weight-medium">{{ $t('RateThisSession') }}</span>
                                <v-spacer></v-spacer>
                                <span class="body-1 grey--text">
                                    {{ rating }}
                                </span>
                                <v-rating 
                                    v-model="rating"
                                    dense
                                    hover 
                                    size="30"
                                    class="mx-2"
                                    color="orange"
                                    background-color="orange lighten-3"
                                ></v-rating>
                                <v-scroll-x-transition>
                                    <v-btn 
                                        icon 
                                        outlined 
                                        color="primary" 
                                        v-if="rating != 0" 
                                        @click="rateAdded"
                                    >
                                        <v-icon>mdi-check-bold</v-icon>
                                    </v-btn>
                                </v-scroll-x-transition>
                            </v-card-actions>
                        </template>
                        <template v-else>
                            <div class="pa-4 d-flex flex-column">
                                <v-textarea 
                                    rounded
                                    outlined 
                                    class="mt-4"
                                    color="primary" 
                                    v-model="comment" 
                                    :label="$t('WriteReviewComment')"
                                    no-resize
                                ></v-textarea>                                
                                <template v-if="!reviewExists">
                                    <v-btn 
                                        v-if="comment != ''" 
                                        rounded 
                                        depressed
                                        color="primary"
                                        class="mb-4 mx-auto"
                                        :loading="submitting" :disabled="submitting" @click="saveReview"
                                    >{{ $t('Post') }}</v-btn>
                                    <v-btn 
                                        v-else 
                                        rounded 
                                        depressed 
                                        class="mb-4 mx-auto"
                                        :loading="submitting" :disabled="submitting" @click="saveReview"
                                    >{{ $t('Skip') }}</v-btn>
                                </template>
                                <template v-else>
                                    <v-btn 
                                        rounded 
                                        depressed 
                                        color="primary"
                                        class="mb-4 mx-auto"
                                        :loading="submitting"
                                        :disabled="submitting" @click="updateReview"
                                    >{{ $t('Save') }}</v-btn>
                                </template>   
                            </div>                         
                        </template>
                    </v-card>
                </template>
            </v-container>
        </template>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Banner from '@/components/pageBanner'
    
    export default {
        name: 'rateSession',
        props: {},
        data: function () {
            return {
                tutorData: {},
                loading: true,
                rating: 0,
                comment: '',
                timeslotId: 0,
                tutorId: 0,
                studentId: 0,
                formSubmited: false,
                showRateReviewForm: true,
                showRateBox: true,
                showReviewBox: false,
                submitting: false,
                reviewId: 0,
                reviewExists: false,
                teachingSubject : {}
            }
        },
        components: {
            Banner
        },        
        computed: {
            ...mapGetters(['user', 'type', 'baseImageUrl', 'preferedLanguage']),
        },
        mounted() {
            this.timeslotId = parseInt(this.$route.params.timeslotId)
            this.fetchTimeSlot()
            this.fetchReviewIfExists()
            this.loading = false
        },
        methods: {
            saveReview() {
                this.submitting = true
                var comment = null

                if (this.comment !== "") {
                    comment = this.comment
                }

                const data = {
                    StudentId: this.studentId,
                    TutorId: this.tutorId,
                    TimeslotId: this.timeslotId,
                    Title: "",
                    Description: comment,
                    rating: this.rating
                }
                this.axios.post(`/Review/Add`, data)
                .then(response => {
                    this.formSubmited = true
                    this.submitting = false
                })
                .catch(function (error) {
                    console.log(error)
                })
            },
            updateReview() {
                this.submitting = true;
                var comment = null;

                if (this.comment !== "") {
                    comment = this.comment
                }

                const data = {
                    Id: this.reviewId,
                    StudentId: this.studentId,
                    TutorId: this.tutorId,
                    TimeslotId: this.timeslotId,
                    Title: "",
                    Description: comment,
                    rating: this.rating
                }
                this.axios.post(`/Review/Edit`, data)
                .then(response => {
                    this.showRateReviewForm = false
                    this.formSubmited = true
                    this.submitting = false
                })
                .catch(function (error) {
                    console.log(error)
                })
            },
            async fetchTimeSlot() {
                await this.axios.get('/TimeSlot/GetTeachingSessionByTimeSlot', {
                        params: {
                            timeslotId: this.timeslotId,
                            languageId: this.preferedLanguage,
                        }
                    })
                    .then(response => {
                        this.tutorId = response.data.teacherId;
                        this.studentId = response.data.studentId;
                        this.teachingSubject = response.data.teachingSubject;
                        this.fetchTutor()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async fetchReviewIfExists() {
                await this.axios.get('/Review/GetReviewByTimeSlotAndStudentId', {
                        params: {
                            timeSlotId: this.timeslotId,
                            studentId: this.user.id
                        }
                    })
                    .then(response => {
                        if (response.data !== "") {
                            this.reviewId = response.data.id;
                            this.rating = response.data.rating,
                                this.showRateBox = false
                            this.showReviewBox = true
                            this.reviewExists = true
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async fetchTutor() {
                await this.axios.get('/Tutor/GetTutorReviewData', {
                    params: {
                        tutorId: this.tutorId,
                    }
                })
                .then(response => {
                    this.tutorData = response.data
                })
                .catch(error => {
                    console.log(error)
                })
            },
            rateAdded() {
                this.showRateBox = false
                this.showReviewBox = true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .avatar-container{
        width: 115px;
        height: 115px;
        background-position: center top;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 100%;
        overflow: hidden;
    }
</style>